import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  sectionTitle: {
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center'
  },
  customFieldBox: {
    flex: '1',
    width: '100%',
    display: 'flex',
    gap: '8px',
    marginTop: '6px'
  },
  customFieldContent: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    gap: '0'
  },
  customFieldActions: {
    display: 'flex',
    alignItems: 'end',
    marginBottom: '8px'
  },
  addButton: {
    color: theme.palette.white_100.main
  },
  noFieldsMessage: {
    textAlign: 'center',
    color: theme.palette.gray_400.main,
    fontStyle: 'italic',
    padding: theme.spacing(2),
    fontSize: '0.875rem'
  },
  fieldName: {
    // 1. Estiliza o container do Input
    '& .MuiInputBase-root': {
      fontWeight: 'bold !important',
      color: `${theme.palette.blue_300.main} !important`,
      fontSize: '.875rem'
    },
    // 2. Estiliza o input propriamente dito
    '& .MuiInputBase-input': {
      fontWeight: 'bold !important',
      color: `${theme.palette.blue_300.main} !important`,
      padding: '4px 0'
    },
    // 3. Remove a linha de baixo se desejar um visual ultra clean
    '& .MuiInput-underline:before, & .MuiInput-underline:after': {
      borderBottom: 'none !important'
    },
    // Garante que o hover não coloque a linha de volta se você não quiser
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important'
    }
  },
  iconButtonDelete: {
    backgroundColor: 'transparent',
    '& svg': {
      color: theme.palette.blue_300.main
    },
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))
